import CodeGenerationHelper from "@/components/code-generation/CodeGenerationHelper";

export default [
    {
        path: '/code-generation',
        component: CodeGenerationHelper
    }
]